import { GetterTree } from "vuex";
import { State } from "@/typings/store/index";
import { StateTestimonios } from "@/typings/store/plugins/easyFirestore/testimonios";

const getters: GetterTree<StateTestimonios, State> = {
  get(state) {
    return state.all;
  },
  getArray(state) {
    return Object.values(state.all);
  },
};

const testimonios = {
  firestorePath: "testimonios",
  firestoreRefType: "collection",
  moduleName: "testimonios",
  statePropName: "all",
  namespaced: true,
  state: {},
  getters,
  mutations: {},
  actions: {},
};

export default testimonios;
